/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

export enum HEADER_PAGES {
  auth = 'auth',
  profile = 'profile',
}

export enum MENU_ITEM_NAMES {
  plans,
  benefits,
  contactUs,
  login,
  signUp,
}

export const MENU_ITEMS_BY_PAGE = {
  [HEADER_PAGES.auth]: [],
  [HEADER_PAGES.profile]: [
    {
      langPath: 'plans',
      name: MENU_ITEM_NAMES.plans,
    },
    {
      langPath: 'benefits',
      name: MENU_ITEM_NAMES.benefits,
    },
    {
      langPath: 'contactUs',
      name: MENU_ITEM_NAMES.contactUs,
    },
  ],
}
